module.exports = __webpack_public_path__ + "img/curve.a172b2c1.svg";